import { useQuery } from '@tanstack/react-query';
import { getGivingOptions } from '@/lib/api/donations';
import { useRegionDetection } from './useRegionDetection';

/**
 * Hook to fetch available giving options
 * Detects region from timezone (more reliable than browser locale)
 * Backend can also use IP detection as fallback/override
 */
export function useGivingOptions() {
  const { detectedRegion, locale, timezone } = useRegionDetection();

  return useQuery({
    queryKey: ['giving-options', detectedRegion, locale, timezone],
    queryFn: () =>
      getGivingOptions({
        region: detectedRegion,
        locale,
        timezone,
      }),
    staleTime: 10 * 60 * 1000, // Cache for 10 minutes
  });
}
